import {useEffect} from 'react';
import {useSearchParams} from 'react-router';
import useSourcePackageBuilderStore from '../../../stores/useSourcePackageBuilderStore';

/**
 * Hook to initialize the Source Package Builder store from URL params.
 * Should be called once at a high level (e.g., ReportPageLayout).
 *
 * This enables:
 * - URL state restoration on page reload
 * - No re-renders from URL changes (only reads once)
 */
export function useInitSourcePackageBuilder() {
    const [searchParams] = useSearchParams();
    const initFromUrl = useSourcePackageBuilderStore(s => s.initFromUrl);
    const _initialized = useSourcePackageBuilderStore(s => s._initialized);

    useEffect(() => {
        if (!_initialized) {
            initFromUrl(searchParams);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_initialized, initFromUrl]); // intentionally omit searchParams — read URL only once on mount
}
